"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classnames = _interopRequireDefault(require("classnames"));

var _times = require("HubStyleTokens/times");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var PopoverContext = _interopRequireWildcard(require("../context/PopoverContext"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _TwoWayTransition = _interopRequireDefault(require("../transitions/TwoWayTransition"));

var _PlacementConstants = require("./PlacementConstants");

var _UIPopoverArrow = _interopRequireDefault(require("./UIPopoverArrow"));

var _UIPopoverBody = _interopRequireDefault(require("./UIPopoverBody"));

var _UIPopoverFooter = _interopRequireDefault(require("./UIPopoverFooter"));

var _UIPopoverHeader = _interopRequireDefault(require("./UIPopoverHeader"));

var _Use = require("./utils/Use");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transition-property: ", ";\n  transition-duration: ", "ms;\n  opacity: ", ";\n  transform: ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isReactNode = function isReactNode(node) {
  return (0, _typeof2.default)(node) !== 'object' || (0, _react.isValidElement)(node) || Array.isArray(node);
};

var transitionDuration = parseInt(_times.POPOVER_TRANSITION_TIMING, 10);

var renderStructuredContent = function renderStructuredContent(content, onOpenChange, showCloseButton) {
  var header = content.header,
      body = content.body,
      footer = content.footer,
      step = content.step;
  return [header && _react.default.createElement(_UIPopoverHeader.default, {
    key: "header",
    showCloseButton: showCloseButton,
    onOpenChange: onOpenChange
  }, header), body && _react.default.createElement(_UIPopoverBody.default, {
    key: "body"
  }, body), (footer || step) && _react.default.createElement(_UIPopoverFooter.default, {
    key: "footer",
    hasStructuredFooter: !!footer,
    hasStep: !!step
  }, step, footer)];
};

var transformOriginMixin = (0, _styledComponents.css)(_templateObject(), ['top', 'bottom', 'left', 'right'].map(function (side) {
  return ".tether-element-attached-" + side + " & { transform-origin: " + side + " }";
}), ['top', 'bottom'].map(function (ySide) {
  return ['left', 'right'].map(function (xSide) {
    return ".tether-element-attached-" + ySide + ".tether-element-attached-" + xSide + " & { transform-origin: " + ySide + " " + xSide + " }";
  });
}));
var PopoverTransitionWrapper = (0, _styledComponents.default)(_TwoWayTransition.default.PlainWrapper).withConfig({
  displayName: "UIPopoverContent__PopoverTransitionWrapper",
  componentId: "sc-172wevb-0"
})(_templateObject2(), function (_ref) {
  var transitioning = _ref.transitioning;
  return transitioning ? 'opacity, transform' : 'none';
}, function (_ref2) {
  var duration = _ref2.duration;
  return duration;
}, function (_ref3) {
  var open = _ref3.open;
  return open ? '1' : '0';
}, function (_ref4) {
  var open = _ref4.open,
      transitioning = _ref4.transitioning;
  if (open && !transitioning) return 'none';
  /* IE bugfix: #5368 */

  return open ? 'scale(1)' : 'scale(.75)';
}, transformOriginMixin);
var UIPopoverContent = (0, _react.forwardRef)(function (props, ref) {
  var animateOnMount = props.animateOnMount,
      animateOnToggle = props.animateOnToggle,
      arrowColor = props.arrowColor,
      arrowSize = props.arrowSize,
      className = props.className,
      content = props.content,
      Content = props.Content,
      renderContent = props.renderContent,
      onCloseComplete = props.onCloseComplete,
      _onCloseStart = props.onCloseStart,
      _onKeyDown = props.onKeyDown,
      _onOpenComplete = props.onOpenComplete,
      onOpenStart = props.onOpenStart,
      open = props.open,
      placement = props.placement,
      style = props.style,
      use = props.use,
      showCloseButton = props.showCloseButton,
      onOpenChange = props.onOpenChange,
      width = props.width,
      rest = (0, _objectWithoutProperties2.default)(props, ["animateOnMount", "animateOnToggle", "arrowColor", "arrowSize", "className", "content", "Content", "renderContent", "onCloseComplete", "onCloseStart", "onKeyDown", "onOpenComplete", "onOpenStart", "open", "placement", "style", "use", "showCloseButton", "onOpenChange", "width"]);

  var _useState = (0, _react.useState)(props.open && !props.animateOnMount),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      openComplete = _useState2[0],
      setOpenComplete = _useState2[1];

  var computedArrowParams = _UIPopoverArrow.default.ARROW_SIZES[arrowSize];
  var renderedContent = content;

  if (open) {
    if (Content) {
      renderedContent = _react.default.createElement(Content, null);
    } else if (renderContent) {
      renderedContent = renderContent();
    }
  }

  var computedOpen = open && !!renderedContent;

  if (process.env.NODE_ENV !== 'production') {
    if (showCloseButton && (isReactNode(renderedContent) || !renderedContent.header)) {
      _devLogger.default.warn({
        message: "UIPopover: `showCloseButton={true}` requires you to provide the `content` prop as an object with a `header`.",
        key: "UIPopover: showCloseButton"
      });
    }
  }

  var renderedPopover = computedOpen && _react.default.createElement(PopoverContext.Provider, {
    value: {
      use: use
    }
  }, _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)(className, _Use.USE_CLASSES[use], 'private-popover uiPopover'),
    "data-open-complete": openComplete,
    onKeyDown: function onKeyDown(evt) {
      if (_onKeyDown) _onKeyDown(evt);
      if (evt.key === 'Escape') onOpenChange((0, _SyntheticEvent.default)(false));
    },
    style: width ? (0, _extends2.default)({
      maxWidth: width,
      width: width
    }, style) : style,
    ref: ref
  }), _react.default.createElement(_UIPopoverArrow.default, {
    color: arrowColor,
    inset: computedArrowParams.inset,
    key: "arrow",
    placement: placement,
    width: computedArrowParams.width,
    popoverUse: use
  }), _react.default.createElement("div", {
    className: "private-popover__inner"
  }, isReactNode(renderedContent) ? renderedContent : renderStructuredContent(renderedContent, onOpenChange, showCloseButton))));

  return _react.default.createElement(_TwoWayTransition.default, {
    onCloseComplete: onCloseComplete,
    onCloseStart: function onCloseStart() {
      setOpenComplete(false);
      if (_onCloseStart) _onCloseStart();
    },
    onOpenComplete: function onOpenComplete() {
      setOpenComplete(true);
      if (_onOpenComplete) _onOpenComplete();
    },
    onOpenStart: onOpenStart,
    transitionOnMount: animateOnMount,
    duration: animateOnToggle ? transitionDuration : 0,
    Wrapper: PopoverTransitionWrapper
  }, renderedPopover);
});
UIPopoverContent.propTypes = {
  animateOnMount: _propTypes.default.bool.isRequired,
  animateOnToggle: _propTypes.default.bool,
  arrowColor: _propTypes.default.string,
  arrowSize: _propTypes.default.oneOf(Object.keys(_UIPopoverArrow.default.ARROW_SIZES)).isRequired,
  content: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.shape({
    header: _propTypes.default.node,
    body: _propTypes.default.node,
    footer: _propTypes.default.node
  })]),
  Content: _propTypes.default.elementType,
  renderContent: _propTypes.default.func,
  onCloseComplete: _propTypes.default.func,
  onCloseStart: _propTypes.default.func,
  onOpenChange: _propTypes.default.func,
  onOpenComplete: _propTypes.default.func,
  onOpenStart: _propTypes.default.func,
  open: _propTypes.default.bool,
  placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  showCloseButton: _propTypes.default.bool,
  use: _propTypes.default.oneOf(Object.keys(_Use.USE_CLASSES)),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
UIPopoverContent.defaultProps = {
  animateOnMount: false,
  open: false,
  placement: 'top',
  use: 'default'
};
UIPopoverContent.displayName = 'UIPopoverContent';
var _default = UIPopoverContent;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/tooltip/UIPopoverContent.js
// module id = 389
// module chunks = 5 6 7